import { render, staticRenderFns } from "./DotMenuActions.vue?vue&type=template&id=fec1659a&"
import script from "./DotMenuActions.vue?vue&type=script&lang=js&"
export * from "./DotMenuActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports